export default [
  { description: 'Colombia', value: 'CO', disabled: true },
  { description: 'Peru', value: 'PE', disabled: true },
  { description: 'Venezuela', value: 'VE' },
];
